"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/admin_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAccountServiceSearchBrandUsersResponse = exports.AdminAccountServiceSearchBrandUsersRequest = exports.AdminAccountServiceSearchTenantUsersResponse = exports.AdminAccountServiceSearchTenantUsersRequest = exports.AdminAccountServiceDeleteTenantUserResponse = exports.AdminAccountServiceDeleteTenantUserRequest = exports.AdminAccountServiceDeleteBrandUserResponse = exports.AdminAccountServiceDeleteBrandUserRequest = exports.AdminAccountServiceAddBrandUserResponse = exports.AdminAccountServiceAddBrandUserRequest = exports.AdminAccountServiceAddTenantUserResponse = exports.AdminAccountServiceAddTenantUserRequest = exports.AdminAccountServiceUpdateBrandProfileResponse = exports.AdminAccountServiceUpdateBrandProfileRequest = exports.AdminAccountServiceAddBrandToTenantResponse = exports.AdminAccountServiceAddBrandToTenantRequest = exports.AdminAccountServiceGetBrandBySlugResponse = exports.AdminAccountServiceGetBrandBySlugRequest = exports.AccessibleBrand = exports.AdminAccountServiceGetAccessibleBrandsResponse = exports.AdminAccountServiceGetAccessibleBrandsRequest = exports.AdminBrandListItem = exports.AdminAccountServiceGetBrandsResponse = exports.AdminAccountServiceGetBrandsRequest = exports.AdminAccountServiceGetCreatorsBySlugResponse = exports.AdminAccountServiceGetCreatorsBySlugRequest = exports.AdminAccountServiceRemoveCreatorFromTenantResponse = exports.AdminAccountServiceRemoveCreatorFromTenantRequest = exports.AdminAccountServiceAddCreatorToTenantResponse = exports.AdminAccountServiceAddCreatorToTenantRequest = exports.AdminAccountServiceGetTenantOwnerBySlugResponse = exports.AdminAccountServiceGetTenantOwnerBySlugRequest = exports.AdminAccountServiceGetCreatorsResponse = exports.AdminAccountServiceGetCreatorsRequest = exports.AdminAccountServiceDeleteAdminUserResponse = exports.AdminAccountServiceDeleteAdminUserRequest = exports.AdminAccountServiceAddAdminUserResponse = exports.AdminAccountServiceAddAdminUserRequest = exports.AdminAccountServiceSetAdminUserIsRedeemerResponse = exports.AdminAccountServiceSetAdminUserIsRedeemerRequest = exports.AdminAccountServiceSetAdminUserRoleResponse = exports.AdminAccountServiceSetAdminUserRoleRequest = exports.AdminAccountServiceSetAdminUserDisabledResponse = exports.AdminAccountServiceSetAdminUserDisabledRequest = exports.AdminAccountServiceGetAdminUsersResponse = exports.AdminAccountServiceGetAdminUsersRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const admin_common_pb_1 = require("./admin_common_pb");
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetAdminUsersRequest
 */
class AdminAccountServiceGetAdminUsersRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetAdminUsersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetAdminUsersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetAdminUsersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetAdminUsersRequest, a, b);
    }
}
exports.AdminAccountServiceGetAdminUsersRequest = AdminAccountServiceGetAdminUsersRequest;
AdminAccountServiceGetAdminUsersRequest.runtime = protobuf_1.proto3;
AdminAccountServiceGetAdminUsersRequest.typeName = "spwn.account.v1.AdminAccountServiceGetAdminUsersRequest";
AdminAccountServiceGetAdminUsersRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetAdminUsersResponse
 */
class AdminAccountServiceGetAdminUsersResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.AdminUser users = 1;
         */
        this.users = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetAdminUsersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetAdminUsersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetAdminUsersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetAdminUsersResponse, a, b);
    }
}
exports.AdminAccountServiceGetAdminUsersResponse = AdminAccountServiceGetAdminUsersResponse;
AdminAccountServiceGetAdminUsersResponse.runtime = protobuf_1.proto3;
AdminAccountServiceGetAdminUsersResponse.typeName = "spwn.account.v1.AdminAccountServiceGetAdminUsersResponse";
AdminAccountServiceGetAdminUsersResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "users", kind: "message", T: admin_common_pb_1.AdminUser, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSetAdminUserDisabledRequest
 */
class AdminAccountServiceSetAdminUserDisabledRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: bool disabled = 2;
         */
        this.disabled = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSetAdminUserDisabledRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSetAdminUserDisabledRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSetAdminUserDisabledRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSetAdminUserDisabledRequest, a, b);
    }
}
exports.AdminAccountServiceSetAdminUserDisabledRequest = AdminAccountServiceSetAdminUserDisabledRequest;
AdminAccountServiceSetAdminUserDisabledRequest.runtime = protobuf_1.proto3;
AdminAccountServiceSetAdminUserDisabledRequest.typeName = "spwn.account.v1.AdminAccountServiceSetAdminUserDisabledRequest";
AdminAccountServiceSetAdminUserDisabledRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSetAdminUserDisabledResponse
 */
class AdminAccountServiceSetAdminUserDisabledResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSetAdminUserDisabledResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSetAdminUserDisabledResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSetAdminUserDisabledResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSetAdminUserDisabledResponse, a, b);
    }
}
exports.AdminAccountServiceSetAdminUserDisabledResponse = AdminAccountServiceSetAdminUserDisabledResponse;
AdminAccountServiceSetAdminUserDisabledResponse.runtime = protobuf_1.proto3;
AdminAccountServiceSetAdminUserDisabledResponse.typeName = "spwn.account.v1.AdminAccountServiceSetAdminUserDisabledResponse";
AdminAccountServiceSetAdminUserDisabledResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: admin_common_pb_1.AdminUser },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSetAdminUserRoleRequest
 */
class AdminAccountServiceSetAdminUserRoleRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSetAdminUserRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSetAdminUserRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSetAdminUserRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSetAdminUserRoleRequest, a, b);
    }
}
exports.AdminAccountServiceSetAdminUserRoleRequest = AdminAccountServiceSetAdminUserRoleRequest;
AdminAccountServiceSetAdminUserRoleRequest.runtime = protobuf_1.proto3;
AdminAccountServiceSetAdminUserRoleRequest.typeName = "spwn.account.v1.AdminAccountServiceSetAdminUserRoleRequest";
AdminAccountServiceSetAdminUserRoleRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSetAdminUserRoleResponse
 */
class AdminAccountServiceSetAdminUserRoleResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSetAdminUserRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSetAdminUserRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSetAdminUserRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSetAdminUserRoleResponse, a, b);
    }
}
exports.AdminAccountServiceSetAdminUserRoleResponse = AdminAccountServiceSetAdminUserRoleResponse;
AdminAccountServiceSetAdminUserRoleResponse.runtime = protobuf_1.proto3;
AdminAccountServiceSetAdminUserRoleResponse.typeName = "spwn.account.v1.AdminAccountServiceSetAdminUserRoleResponse";
AdminAccountServiceSetAdminUserRoleResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: admin_common_pb_1.AdminUser },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSetAdminUserIsRedeemerRequest
 */
class AdminAccountServiceSetAdminUserIsRedeemerRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        /**
         * チケット・グッズのもぎり権限
         *
         * @generated from field: bool is_redeemer = 2;
         */
        this.isRedeemer = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSetAdminUserIsRedeemerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSetAdminUserIsRedeemerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSetAdminUserIsRedeemerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSetAdminUserIsRedeemerRequest, a, b);
    }
}
exports.AdminAccountServiceSetAdminUserIsRedeemerRequest = AdminAccountServiceSetAdminUserIsRedeemerRequest;
AdminAccountServiceSetAdminUserIsRedeemerRequest.runtime = protobuf_1.proto3;
AdminAccountServiceSetAdminUserIsRedeemerRequest.typeName = "spwn.account.v1.AdminAccountServiceSetAdminUserIsRedeemerRequest";
AdminAccountServiceSetAdminUserIsRedeemerRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_redeemer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSetAdminUserIsRedeemerResponse
 */
class AdminAccountServiceSetAdminUserIsRedeemerResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSetAdminUserIsRedeemerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSetAdminUserIsRedeemerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSetAdminUserIsRedeemerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSetAdminUserIsRedeemerResponse, a, b);
    }
}
exports.AdminAccountServiceSetAdminUserIsRedeemerResponse = AdminAccountServiceSetAdminUserIsRedeemerResponse;
AdminAccountServiceSetAdminUserIsRedeemerResponse.runtime = protobuf_1.proto3;
AdminAccountServiceSetAdminUserIsRedeemerResponse.typeName = "spwn.account.v1.AdminAccountServiceSetAdminUserIsRedeemerResponse";
AdminAccountServiceSetAdminUserIsRedeemerResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: admin_common_pb_1.AdminUser },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddAdminUserRequest
 */
class AdminAccountServiceAddAdminUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string role = 2;
         */
        this.role = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddAdminUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddAdminUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddAdminUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddAdminUserRequest, a, b);
    }
}
exports.AdminAccountServiceAddAdminUserRequest = AdminAccountServiceAddAdminUserRequest;
AdminAccountServiceAddAdminUserRequest.runtime = protobuf_1.proto3;
AdminAccountServiceAddAdminUserRequest.typeName = "spwn.account.v1.AdminAccountServiceAddAdminUserRequest";
AdminAccountServiceAddAdminUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddAdminUserResponse
 */
class AdminAccountServiceAddAdminUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddAdminUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddAdminUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddAdminUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddAdminUserResponse, a, b);
    }
}
exports.AdminAccountServiceAddAdminUserResponse = AdminAccountServiceAddAdminUserResponse;
AdminAccountServiceAddAdminUserResponse.runtime = protobuf_1.proto3;
AdminAccountServiceAddAdminUserResponse.typeName = "spwn.account.v1.AdminAccountServiceAddAdminUserResponse";
AdminAccountServiceAddAdminUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: admin_common_pb_1.AdminUser },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceDeleteAdminUserRequest
 */
class AdminAccountServiceDeleteAdminUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceDeleteAdminUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceDeleteAdminUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceDeleteAdminUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceDeleteAdminUserRequest, a, b);
    }
}
exports.AdminAccountServiceDeleteAdminUserRequest = AdminAccountServiceDeleteAdminUserRequest;
AdminAccountServiceDeleteAdminUserRequest.runtime = protobuf_1.proto3;
AdminAccountServiceDeleteAdminUserRequest.typeName = "spwn.account.v1.AdminAccountServiceDeleteAdminUserRequest";
AdminAccountServiceDeleteAdminUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceDeleteAdminUserResponse
 */
class AdminAccountServiceDeleteAdminUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceDeleteAdminUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceDeleteAdminUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceDeleteAdminUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceDeleteAdminUserResponse, a, b);
    }
}
exports.AdminAccountServiceDeleteAdminUserResponse = AdminAccountServiceDeleteAdminUserResponse;
AdminAccountServiceDeleteAdminUserResponse.runtime = protobuf_1.proto3;
AdminAccountServiceDeleteAdminUserResponse.typeName = "spwn.account.v1.AdminAccountServiceDeleteAdminUserResponse";
AdminAccountServiceDeleteAdminUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: admin_common_pb_1.AdminUser },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetCreatorsRequest
 */
class AdminAccountServiceGetCreatorsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetCreatorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetCreatorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetCreatorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetCreatorsRequest, a, b);
    }
}
exports.AdminAccountServiceGetCreatorsRequest = AdminAccountServiceGetCreatorsRequest;
AdminAccountServiceGetCreatorsRequest.runtime = protobuf_1.proto3;
AdminAccountServiceGetCreatorsRequest.typeName = "spwn.account.v1.AdminAccountServiceGetCreatorsRequest";
AdminAccountServiceGetCreatorsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetCreatorsResponse
 */
class AdminAccountServiceGetCreatorsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.AdminCreatorCore creators = 1;
         */
        this.creators = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetCreatorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetCreatorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetCreatorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetCreatorsResponse, a, b);
    }
}
exports.AdminAccountServiceGetCreatorsResponse = AdminAccountServiceGetCreatorsResponse;
AdminAccountServiceGetCreatorsResponse.runtime = protobuf_1.proto3;
AdminAccountServiceGetCreatorsResponse.typeName = "spwn.account.v1.AdminAccountServiceGetCreatorsResponse";
AdminAccountServiceGetCreatorsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creators", kind: "message", T: admin_common_pb_1.AdminCreatorCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetTenantOwnerBySlugRequest
 */
class AdminAccountServiceGetTenantOwnerBySlugRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_slug = 1;
         */
        this.brandSlug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetTenantOwnerBySlugRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetTenantOwnerBySlugRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetTenantOwnerBySlugRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetTenantOwnerBySlugRequest, a, b);
    }
}
exports.AdminAccountServiceGetTenantOwnerBySlugRequest = AdminAccountServiceGetTenantOwnerBySlugRequest;
AdminAccountServiceGetTenantOwnerBySlugRequest.runtime = protobuf_1.proto3;
AdminAccountServiceGetTenantOwnerBySlugRequest.typeName = "spwn.account.v1.AdminAccountServiceGetTenantOwnerBySlugRequest";
AdminAccountServiceGetTenantOwnerBySlugRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetTenantOwnerBySlugResponse
 */
class AdminAccountServiceGetTenantOwnerBySlugResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetTenantOwnerBySlugResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetTenantOwnerBySlugResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetTenantOwnerBySlugResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetTenantOwnerBySlugResponse, a, b);
    }
}
exports.AdminAccountServiceGetTenantOwnerBySlugResponse = AdminAccountServiceGetTenantOwnerBySlugResponse;
AdminAccountServiceGetTenantOwnerBySlugResponse.runtime = protobuf_1.proto3;
AdminAccountServiceGetTenantOwnerBySlugResponse.typeName = "spwn.account.v1.AdminAccountServiceGetTenantOwnerBySlugResponse";
AdminAccountServiceGetTenantOwnerBySlugResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "message", T: admin_common_pb_1.AdminCreator },
    { no: 2, name: "bank", kind: "message", T: admin_common_pb_1.AdminBankAccount, opt: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddCreatorToTenantRequest
 */
class AdminAccountServiceAddCreatorToTenantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string brand_slug = 2;
         */
        this.brandSlug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddCreatorToTenantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddCreatorToTenantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddCreatorToTenantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddCreatorToTenantRequest, a, b);
    }
}
exports.AdminAccountServiceAddCreatorToTenantRequest = AdminAccountServiceAddCreatorToTenantRequest;
AdminAccountServiceAddCreatorToTenantRequest.runtime = protobuf_1.proto3;
AdminAccountServiceAddCreatorToTenantRequest.typeName = "spwn.account.v1.AdminAccountServiceAddCreatorToTenantRequest";
AdminAccountServiceAddCreatorToTenantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddCreatorToTenantResponse
 */
class AdminAccountServiceAddCreatorToTenantResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddCreatorToTenantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddCreatorToTenantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddCreatorToTenantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddCreatorToTenantResponse, a, b);
    }
}
exports.AdminAccountServiceAddCreatorToTenantResponse = AdminAccountServiceAddCreatorToTenantResponse;
AdminAccountServiceAddCreatorToTenantResponse.runtime = protobuf_1.proto3;
AdminAccountServiceAddCreatorToTenantResponse.typeName = "spwn.account.v1.AdminAccountServiceAddCreatorToTenantResponse";
AdminAccountServiceAddCreatorToTenantResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "message", T: admin_common_pb_1.AdminCreatorCore },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceRemoveCreatorFromTenantRequest
 */
class AdminAccountServiceRemoveCreatorFromTenantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string brand_slug = 2;
         */
        this.brandSlug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceRemoveCreatorFromTenantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceRemoveCreatorFromTenantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceRemoveCreatorFromTenantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceRemoveCreatorFromTenantRequest, a, b);
    }
}
exports.AdminAccountServiceRemoveCreatorFromTenantRequest = AdminAccountServiceRemoveCreatorFromTenantRequest;
AdminAccountServiceRemoveCreatorFromTenantRequest.runtime = protobuf_1.proto3;
AdminAccountServiceRemoveCreatorFromTenantRequest.typeName = "spwn.account.v1.AdminAccountServiceRemoveCreatorFromTenantRequest";
AdminAccountServiceRemoveCreatorFromTenantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceRemoveCreatorFromTenantResponse
 */
class AdminAccountServiceRemoveCreatorFromTenantResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceRemoveCreatorFromTenantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceRemoveCreatorFromTenantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceRemoveCreatorFromTenantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceRemoveCreatorFromTenantResponse, a, b);
    }
}
exports.AdminAccountServiceRemoveCreatorFromTenantResponse = AdminAccountServiceRemoveCreatorFromTenantResponse;
AdminAccountServiceRemoveCreatorFromTenantResponse.runtime = protobuf_1.proto3;
AdminAccountServiceRemoveCreatorFromTenantResponse.typeName = "spwn.account.v1.AdminAccountServiceRemoveCreatorFromTenantResponse";
AdminAccountServiceRemoveCreatorFromTenantResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "message", T: admin_common_pb_1.AdminCreatorCore },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetCreatorsBySlugRequest
 */
class AdminAccountServiceGetCreatorsBySlugRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_slug = 1;
         */
        this.brandSlug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetCreatorsBySlugRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetCreatorsBySlugRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetCreatorsBySlugRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetCreatorsBySlugRequest, a, b);
    }
}
exports.AdminAccountServiceGetCreatorsBySlugRequest = AdminAccountServiceGetCreatorsBySlugRequest;
AdminAccountServiceGetCreatorsBySlugRequest.runtime = protobuf_1.proto3;
AdminAccountServiceGetCreatorsBySlugRequest.typeName = "spwn.account.v1.AdminAccountServiceGetCreatorsBySlugRequest";
AdminAccountServiceGetCreatorsBySlugRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetCreatorsBySlugResponse
 */
class AdminAccountServiceGetCreatorsBySlugResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.AdminCreatorCore creators = 1;
         */
        this.creators = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetCreatorsBySlugResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetCreatorsBySlugResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetCreatorsBySlugResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetCreatorsBySlugResponse, a, b);
    }
}
exports.AdminAccountServiceGetCreatorsBySlugResponse = AdminAccountServiceGetCreatorsBySlugResponse;
AdminAccountServiceGetCreatorsBySlugResponse.runtime = protobuf_1.proto3;
AdminAccountServiceGetCreatorsBySlugResponse.typeName = "spwn.account.v1.AdminAccountServiceGetCreatorsBySlugResponse";
AdminAccountServiceGetCreatorsBySlugResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creators", kind: "message", T: admin_common_pb_1.AdminCreatorCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetBrandsRequest
 */
class AdminAccountServiceGetBrandsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetBrandsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetBrandsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetBrandsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetBrandsRequest, a, b);
    }
}
exports.AdminAccountServiceGetBrandsRequest = AdminAccountServiceGetBrandsRequest;
AdminAccountServiceGetBrandsRequest.runtime = protobuf_1.proto3;
AdminAccountServiceGetBrandsRequest.typeName = "spwn.account.v1.AdminAccountServiceGetBrandsRequest";
AdminAccountServiceGetBrandsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetBrandsResponse
 */
class AdminAccountServiceGetBrandsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 販売元一覧
         *
         * @generated from field: repeated spwn.account.v1.AdminBrandListItem brands = 1;
         */
        this.brands = [];
        /**
         * トータル件数
         *
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        /**
         * 一覧全体の最後のページ番号
         *
         * @generated from field: int32 last_page_number = 3;
         */
        this.lastPageNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetBrandsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetBrandsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetBrandsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetBrandsResponse, a, b);
    }
}
exports.AdminAccountServiceGetBrandsResponse = AdminAccountServiceGetBrandsResponse;
AdminAccountServiceGetBrandsResponse.runtime = protobuf_1.proto3;
AdminAccountServiceGetBrandsResponse.typeName = "spwn.account.v1.AdminAccountServiceGetBrandsResponse";
AdminAccountServiceGetBrandsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brands", kind: "message", T: AdminBrandListItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 販売元一覧用（descriptionなし）
 *
 * @generated from message spwn.account.v1.AdminBrandListItem
 */
class AdminBrandListItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        /**
         * @generated from field: spwn.account.v1.AdminBrandPublishStatus publish_status = 4;
         */
        this.publishStatus = admin_common_pb_1.AdminBrandPublishStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminBrandListItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminBrandListItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminBrandListItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminBrandListItem, a, b);
    }
}
exports.AdminBrandListItem = AdminBrandListItem;
AdminBrandListItem.runtime = protobuf_1.proto3;
AdminBrandListItem.typeName = "spwn.account.v1.AdminBrandListItem";
AdminBrandListItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(admin_common_pb_1.AdminBrandPublishStatus) },
    { no: 5, name: "created_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetAccessibleBrandsRequest
 */
class AdminAccountServiceGetAccessibleBrandsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetAccessibleBrandsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetAccessibleBrandsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetAccessibleBrandsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetAccessibleBrandsRequest, a, b);
    }
}
exports.AdminAccountServiceGetAccessibleBrandsRequest = AdminAccountServiceGetAccessibleBrandsRequest;
AdminAccountServiceGetAccessibleBrandsRequest.runtime = protobuf_1.proto3;
AdminAccountServiceGetAccessibleBrandsRequest.typeName = "spwn.account.v1.AdminAccountServiceGetAccessibleBrandsRequest";
AdminAccountServiceGetAccessibleBrandsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetAccessibleBrandsResponse
 */
class AdminAccountServiceGetAccessibleBrandsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * リクエストユーザがアクセス可能なブランド一覧
         *
         * @generated from field: repeated spwn.account.v1.AccessibleBrand brands = 1;
         */
        this.brands = [];
        /**
         * トータル件数
         *
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        /**
         * 一覧全体の最後のページ番号
         *
         * @generated from field: int32 last_page_number = 3;
         */
        this.lastPageNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetAccessibleBrandsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetAccessibleBrandsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetAccessibleBrandsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetAccessibleBrandsResponse, a, b);
    }
}
exports.AdminAccountServiceGetAccessibleBrandsResponse = AdminAccountServiceGetAccessibleBrandsResponse;
AdminAccountServiceGetAccessibleBrandsResponse.runtime = protobuf_1.proto3;
AdminAccountServiceGetAccessibleBrandsResponse.typeName = "spwn.account.v1.AdminAccountServiceGetAccessibleBrandsResponse";
AdminAccountServiceGetAccessibleBrandsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brands", kind: "message", T: AccessibleBrand, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * リクエストユーザがアクセス可能なブランド
 *
 * @generated from message spwn.account.v1.AccessibleBrand
 */
class AccessibleBrand extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_slug = 2;
         */
        this.brandSlug = "";
        /**
         * @generated from field: string brand_name = 3;
         */
        this.brandName = "";
        /**
         * @generated from field: string tenant_id = 5;
         */
        this.tenantId = "";
        /**
         * @generated from field: string tenant_slug = 6;
         */
        this.tenantSlug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AccessibleBrand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AccessibleBrand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AccessibleBrand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AccessibleBrand, a, b);
    }
}
exports.AccessibleBrand = AccessibleBrand;
AccessibleBrand.runtime = protobuf_1.proto3;
AccessibleBrand.typeName = "spwn.account.v1.AccessibleBrand";
AccessibleBrand.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "brand_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tenant_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetBrandBySlugRequest
 */
class AdminAccountServiceGetBrandBySlugRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_slug = 1;
         */
        this.brandSlug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetBrandBySlugRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetBrandBySlugRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetBrandBySlugRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetBrandBySlugRequest, a, b);
    }
}
exports.AdminAccountServiceGetBrandBySlugRequest = AdminAccountServiceGetBrandBySlugRequest;
AdminAccountServiceGetBrandBySlugRequest.runtime = protobuf_1.proto3;
AdminAccountServiceGetBrandBySlugRequest.typeName = "spwn.account.v1.AdminAccountServiceGetBrandBySlugRequest";
AdminAccountServiceGetBrandBySlugRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceGetBrandBySlugResponse
 */
class AdminAccountServiceGetBrandBySlugResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceGetBrandBySlugResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceGetBrandBySlugResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceGetBrandBySlugResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceGetBrandBySlugResponse, a, b);
    }
}
exports.AdminAccountServiceGetBrandBySlugResponse = AdminAccountServiceGetBrandBySlugResponse;
AdminAccountServiceGetBrandBySlugResponse.runtime = protobuf_1.proto3;
AdminAccountServiceGetBrandBySlugResponse.typeName = "spwn.account.v1.AdminAccountServiceGetBrandBySlugResponse";
AdminAccountServiceGetBrandBySlugResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: admin_common_pb_1.AdminBrand },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddBrandToTenantRequest
 */
class AdminAccountServiceAddBrandToTenantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        /**
         * @generated from field: spwn.account.v1.AdminBrandPublishStatus publish_status = 7;
         */
        this.publishStatus = admin_common_pb_1.AdminBrandPublishStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddBrandToTenantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddBrandToTenantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddBrandToTenantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddBrandToTenantRequest, a, b);
    }
}
exports.AdminAccountServiceAddBrandToTenantRequest = AdminAccountServiceAddBrandToTenantRequest;
AdminAccountServiceAddBrandToTenantRequest.runtime = protobuf_1.proto3;
AdminAccountServiceAddBrandToTenantRequest.typeName = "spwn.account.v1.AdminAccountServiceAddBrandToTenantRequest";
AdminAccountServiceAddBrandToTenantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "cover_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(admin_common_pb_1.AdminBrandPublishStatus) },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddBrandToTenantResponse
 */
class AdminAccountServiceAddBrandToTenantResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddBrandToTenantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddBrandToTenantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddBrandToTenantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddBrandToTenantResponse, a, b);
    }
}
exports.AdminAccountServiceAddBrandToTenantResponse = AdminAccountServiceAddBrandToTenantResponse;
AdminAccountServiceAddBrandToTenantResponse.runtime = protobuf_1.proto3;
AdminAccountServiceAddBrandToTenantResponse.typeName = "spwn.account.v1.AdminAccountServiceAddBrandToTenantResponse";
AdminAccountServiceAddBrandToTenantResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: admin_common_pb_1.AdminBrand },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceUpdateBrandProfileRequest
 */
class AdminAccountServiceUpdateBrandProfileRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string brand_id = 2;
         */
        this.brandId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: spwn.account.v1.AdminBrandPublishStatus publish_status = 7;
         */
        this.publishStatus = admin_common_pb_1.AdminBrandPublishStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceUpdateBrandProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceUpdateBrandProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceUpdateBrandProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceUpdateBrandProfileRequest, a, b);
    }
}
exports.AdminAccountServiceUpdateBrandProfileRequest = AdminAccountServiceUpdateBrandProfileRequest;
AdminAccountServiceUpdateBrandProfileRequest.runtime = protobuf_1.proto3;
AdminAccountServiceUpdateBrandProfileRequest.typeName = "spwn.account.v1.AdminAccountServiceUpdateBrandProfileRequest";
AdminAccountServiceUpdateBrandProfileRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "cover_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(admin_common_pb_1.AdminBrandPublishStatus) },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceUpdateBrandProfileResponse
 */
class AdminAccountServiceUpdateBrandProfileResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceUpdateBrandProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceUpdateBrandProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceUpdateBrandProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceUpdateBrandProfileResponse, a, b);
    }
}
exports.AdminAccountServiceUpdateBrandProfileResponse = AdminAccountServiceUpdateBrandProfileResponse;
AdminAccountServiceUpdateBrandProfileResponse.runtime = protobuf_1.proto3;
AdminAccountServiceUpdateBrandProfileResponse.typeName = "spwn.account.v1.AdminAccountServiceUpdateBrandProfileResponse";
AdminAccountServiceUpdateBrandProfileResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: admin_common_pb_1.AdminBrand },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddTenantUserRequest
 */
class AdminAccountServiceAddTenantUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string email = 1;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddTenantUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddTenantUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddTenantUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddTenantUserRequest, a, b);
    }
}
exports.AdminAccountServiceAddTenantUserRequest = AdminAccountServiceAddTenantUserRequest;
AdminAccountServiceAddTenantUserRequest.runtime = protobuf_1.proto3;
AdminAccountServiceAddTenantUserRequest.typeName = "spwn.account.v1.AdminAccountServiceAddTenantUserRequest";
AdminAccountServiceAddTenantUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddTenantUserResponse
 */
class AdminAccountServiceAddTenantUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddTenantUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddTenantUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddTenantUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddTenantUserResponse, a, b);
    }
}
exports.AdminAccountServiceAddTenantUserResponse = AdminAccountServiceAddTenantUserResponse;
AdminAccountServiceAddTenantUserResponse.runtime = protobuf_1.proto3;
AdminAccountServiceAddTenantUserResponse.typeName = "spwn.account.v1.AdminAccountServiceAddTenantUserResponse";
AdminAccountServiceAddTenantUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddBrandUserRequest
 */
class AdminAccountServiceAddBrandUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string email = 1;
         */
        this.email = "";
        /**
         * @generated from field: string role = 2;
         */
        this.role = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddBrandUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddBrandUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddBrandUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddBrandUserRequest, a, b);
    }
}
exports.AdminAccountServiceAddBrandUserRequest = AdminAccountServiceAddBrandUserRequest;
AdminAccountServiceAddBrandUserRequest.runtime = protobuf_1.proto3;
AdminAccountServiceAddBrandUserRequest.typeName = "spwn.account.v1.AdminAccountServiceAddBrandUserRequest";
AdminAccountServiceAddBrandUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceAddBrandUserResponse
 */
class AdminAccountServiceAddBrandUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceAddBrandUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceAddBrandUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceAddBrandUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceAddBrandUserResponse, a, b);
    }
}
exports.AdminAccountServiceAddBrandUserResponse = AdminAccountServiceAddBrandUserResponse;
AdminAccountServiceAddBrandUserResponse.runtime = protobuf_1.proto3;
AdminAccountServiceAddBrandUserResponse.typeName = "spwn.account.v1.AdminAccountServiceAddBrandUserResponse";
AdminAccountServiceAddBrandUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceDeleteBrandUserRequest
 */
class AdminAccountServiceDeleteBrandUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceDeleteBrandUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceDeleteBrandUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceDeleteBrandUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceDeleteBrandUserRequest, a, b);
    }
}
exports.AdminAccountServiceDeleteBrandUserRequest = AdminAccountServiceDeleteBrandUserRequest;
AdminAccountServiceDeleteBrandUserRequest.runtime = protobuf_1.proto3;
AdminAccountServiceDeleteBrandUserRequest.typeName = "spwn.account.v1.AdminAccountServiceDeleteBrandUserRequest";
AdminAccountServiceDeleteBrandUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceDeleteBrandUserResponse
 */
class AdminAccountServiceDeleteBrandUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceDeleteBrandUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceDeleteBrandUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceDeleteBrandUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceDeleteBrandUserResponse, a, b);
    }
}
exports.AdminAccountServiceDeleteBrandUserResponse = AdminAccountServiceDeleteBrandUserResponse;
AdminAccountServiceDeleteBrandUserResponse.runtime = protobuf_1.proto3;
AdminAccountServiceDeleteBrandUserResponse.typeName = "spwn.account.v1.AdminAccountServiceDeleteBrandUserResponse";
AdminAccountServiceDeleteBrandUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceDeleteTenantUserRequest
 */
class AdminAccountServiceDeleteTenantUserRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceDeleteTenantUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceDeleteTenantUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceDeleteTenantUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceDeleteTenantUserRequest, a, b);
    }
}
exports.AdminAccountServiceDeleteTenantUserRequest = AdminAccountServiceDeleteTenantUserRequest;
AdminAccountServiceDeleteTenantUserRequest.runtime = protobuf_1.proto3;
AdminAccountServiceDeleteTenantUserRequest.typeName = "spwn.account.v1.AdminAccountServiceDeleteTenantUserRequest";
AdminAccountServiceDeleteTenantUserRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceDeleteTenantUserResponse
 */
class AdminAccountServiceDeleteTenantUserResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceDeleteTenantUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceDeleteTenantUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceDeleteTenantUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceDeleteTenantUserResponse, a, b);
    }
}
exports.AdminAccountServiceDeleteTenantUserResponse = AdminAccountServiceDeleteTenantUserResponse;
AdminAccountServiceDeleteTenantUserResponse.runtime = protobuf_1.proto3;
AdminAccountServiceDeleteTenantUserResponse.typeName = "spwn.account.v1.AdminAccountServiceDeleteTenantUserResponse";
AdminAccountServiceDeleteTenantUserResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSearchTenantUsersRequest
 */
class AdminAccountServiceSearchTenantUsersRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSearchTenantUsersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSearchTenantUsersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSearchTenantUsersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSearchTenantUsersRequest, a, b);
    }
}
exports.AdminAccountServiceSearchTenantUsersRequest = AdminAccountServiceSearchTenantUsersRequest;
AdminAccountServiceSearchTenantUsersRequest.runtime = protobuf_1.proto3;
AdminAccountServiceSearchTenantUsersRequest.typeName = "spwn.account.v1.AdminAccountServiceSearchTenantUsersRequest";
AdminAccountServiceSearchTenantUsersRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSearchTenantUsersResponse
 */
class AdminAccountServiceSearchTenantUsersResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.AdminUserBasicInfo users = 1;
         */
        this.users = [];
        /**
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        /**
         * @generated from field: int32 last_page_number = 3;
         */
        this.lastPageNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSearchTenantUsersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSearchTenantUsersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSearchTenantUsersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSearchTenantUsersResponse, a, b);
    }
}
exports.AdminAccountServiceSearchTenantUsersResponse = AdminAccountServiceSearchTenantUsersResponse;
AdminAccountServiceSearchTenantUsersResponse.runtime = protobuf_1.proto3;
AdminAccountServiceSearchTenantUsersResponse.typeName = "spwn.account.v1.AdminAccountServiceSearchTenantUsersResponse";
AdminAccountServiceSearchTenantUsersResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "users", kind: "message", T: admin_common_pb_1.AdminUserBasicInfo, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSearchBrandUsersRequest
 */
class AdminAccountServiceSearchBrandUsersRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSearchBrandUsersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSearchBrandUsersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSearchBrandUsersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSearchBrandUsersRequest, a, b);
    }
}
exports.AdminAccountServiceSearchBrandUsersRequest = AdminAccountServiceSearchBrandUsersRequest;
AdminAccountServiceSearchBrandUsersRequest.runtime = protobuf_1.proto3;
AdminAccountServiceSearchBrandUsersRequest.typeName = "spwn.account.v1.AdminAccountServiceSearchBrandUsersRequest";
AdminAccountServiceSearchBrandUsersRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.AdminAccountServiceSearchBrandUsersResponse
 */
class AdminAccountServiceSearchBrandUsersResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.AdminUserBasicInfo users = 1;
         */
        this.users = [];
        /**
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        /**
         * @generated from field: int32 last_page_number = 3;
         */
        this.lastPageNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminAccountServiceSearchBrandUsersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAccountServiceSearchBrandUsersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAccountServiceSearchBrandUsersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminAccountServiceSearchBrandUsersResponse, a, b);
    }
}
exports.AdminAccountServiceSearchBrandUsersResponse = AdminAccountServiceSearchBrandUsersResponse;
AdminAccountServiceSearchBrandUsersResponse.runtime = protobuf_1.proto3;
AdminAccountServiceSearchBrandUsersResponse.typeName = "spwn.account.v1.AdminAccountServiceSearchBrandUsersResponse";
AdminAccountServiceSearchBrandUsersResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "users", kind: "message", T: admin_common_pb_1.AdminUserBasicInfo, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
//# sourceMappingURL=admin_service_pb.js.map